<template>
  <div class="page-project" v-loading="fullscreenLoading">
    <div class="left-right-content clearfix">
      <div class="c-left">
        <div class="paeparation">
          <div class="types-list">
            <div class="type-item clearfix">
              <div class="tit">项目类别：</div>
              <ul class="cases clearfix">
    <!--            <li class="active">全部</li>-->
                <li  :class="selectTypes[index].classType" v-for="(item, index) in selectTypes" :key="index" @click="selectType(index,item)">{{item.tag}}</li>
    <!--            <li  v-for="(item, index) in selectTypes" :key="index" @click="selectType(index,item)">{{item.tag}}</li>-->

              </ul>
            </div>
            <div class="type-item clearfix">
              <div class="tit">项目进度：</div>
              <ul class="cases clearfix">
                <li :class="selectStatesIndex==0?'active':''" @click="selectState(0)">全部</li>
                <li :class="selectStatesIndex==2?'active':''" @click="selectState(2)">报价中</li>
                <li :class="selectStatesIndex==3?'active':''" @click="selectState(3)">已结束</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="paeparation sear-item">
          <div class="search">
            <el-input class="ipt" clearable size="large" v-model="searchIpt" placeholder="请输入项目名称"></el-input>
            <div class="btn" @click="getActivityList(1)">
              <i class="el-icon-search" ></i> 搜索
            </div>
          </div>
        </div>
        <div class="projn-list">
          <div class="projn-item" v-for="(item,index) in data" :key="index">
            <router-link
                :to="{path:'/pro/detail?id='+item.id+'&plate=3'}"
              class="left-img"
              :style="{backgroundImage: 'url(' + item.activityImage + ')'}"
            >
            </router-link>
            <!-- mobile-mask 只需要填写跳转链接即可 pc上无影响 移动端作为遮罩将会覆盖到wrap顶层实现跳转 -->
            <router-link :to="{path:'/pro/detail?id='+item.id+'&plate=3'}" class="mobile-mask"></router-link>
            <div class="itemn-info">
              <div class="item-tit">
                <div class="tit-type clearfix">
                  <router-link :to="{path:'/pro/detail?id='+item.id+'&plate=3'}" class="tit-nam">{{ item.activityName }}</router-link>

                  <span class="type bjz" v-if="item.showStatus == '报价中'">{{ item.showStatus }}</span>
                  <span class="type yjs" v-if="item.showStatus == '已结束'">{{ item.showStatus }}</span>

                </div>
                <span class="item-date">{{item.formatDateStr}}</span>
              </div>
              <div class="pro-type">项目类型：{{item.showProType}}</div>
              <div class="btn-has-user">
                <div class="pro-end-date">报价截止时间：{{item.showTime}}</div>
                <div class="hs-user">{{ item.quoteNum }}人参与报价</div>
              </div>
            </div>
          </div>
          <div class="pagintion-f">
            <el-pagination
                background
                @current-change="getActivityList"
                layout="prev, pager, next"
                :current-page=currentPage
                :page-size="5"
                :total="total"
                :hide-on-single-page="true">
            </el-pagination>
          </div>
        </div>
        <!-- <div class="right-select">
          <el-dropdown>
            <el-button type="primary">
              {{selectStates[selectStatesIndex]}}<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="selectState(0)">全部</el-dropdown-item>
              <el-dropdown-item @click.native="selectState(2)">进行中</el-dropdown-item>
              <el-dropdown-item @click.native="selectState(3)">已结束</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div> -->
        <!-- <div class="activities-content"  v-loading="fullscreenLoading">

          <div class="active-item-one" v-for="(item, index) in data" :key="index">
            <div class="act-infos">
              <router-link :to="{path:'/pro/detail?id='+item.id}" class="act-zhuti-img">
                <img :src="item.activityImage" alt="">
                <div class="act-zt jxz" v-if="item.showStatus=='报价中'"></div>
                <div class="act-zt yjs" v-if="item.showStatus=='已结束'"></div>
                <div class="m-type">{{item.showProType}}</div>
              </router-link>
              <div class="zpzj-tit"><router-link :to="{path:'/pro/detail?id='+item.id}">{{item.activityName}}</router-link></div>
              <div class="end-time">截止日期：{{item.showTime}}</div>
            </div>
          </div>

          <div class="pagintion-f">
            <el-pagination
                    background
                    @current-change="getActivityList"
                    layout="prev, pager, next"
                    :current-page=currentPage
                    :page-size="5"
                    :total="total">
            </el-pagination>
          </div>
        </div> -->
      </div>
      <div class="c-right">
        <div class="pro-bj-wrap">
          <div class="pro-bj-tit">
            <span class="pro-zhin">项目报价指南</span>
            <router-link to="/recruit?plate=3" class="more">了解更多</router-link>
          </div>
          <div class="zn-list">
            <router-link to="?plate=3" class="zn-item">
              <span class="num-idx"><i>1</i></span>
              <span class="zn-tit">注册并登录平台</span>
            </router-link>
            <router-link to="?plate=3" class="zn-item">
              <span class="num-idx"><i>2</i></span>
              <span class="zn-tit">完善履历</span>
            </router-link>
            <router-link to="?plate=3" class="zn-item">
              <span class="num-idx"><i>3</i></span>
              <span class="zn-tit">发布作品</span>
            </router-link>
            <router-link to="?plate=3" class="zn-item">
              <span class="num-idx"><i>4</i></span>
              <span class="zn-tit">申请项目合伙人身份</span>
            </router-link>
            <div class="zn-item">
              <span class="num-idx"><i>5</i></span>
              <span class="zn-tit">前往报价</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ul class="right-side-btns">
      <router-link to="/recruit?plate=3"><li>招募合伙人</li></router-link>
    </ul>
  </div>
</template>

<script type="text/ecmascript-6">
  import updateTdk from "@/utils/tdk";
export default {
  components: {

  },
  data () {
    return {
      currentPage:1,
      total:0,
      searchIpt: '',
      selectTypesIndex: 0,
      tagId:0,
      selectTypes: [{id:0,tag:'全部',classType:'active'}],
      selectStatesIndex: 0,
      selectStates: ['状态', '未发布', '进行中', '已结束'],
      data: [],
      fullscreenLoading: true,
    }
  },
  tdk() {
    return {
      title: this.headTitle,
      description: this.headDesc,
      keywords: this.headKeywords,
      ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com">`
    };
  },
  serverPrefetch() {
    // this.setSeo();
    // updateTdk.call(this);
    this.getActivityList(1);
  },
    beforeRouteUpdate(to, from, next) {
        // 一般建议路由变更采用计算属性或者store直接绑定
        // 特殊情况处理可以采用如下方案 重新注册数据返回处理
        this.getActivityList(1)
        next();
    },
  mounted() {
    this.getSystemTags();
    this.getActivityList(1);
  },
  methods:{
    setSeo() {
      this.headTitle = "项目大厅——人人动画网【官网】";
      this.headKeywords = "分镜外包,动画外包,音效外包,后期剪辑外包";
      this.headDesc = "人人动画，一直致力于为动画项目外包提供完美解决方案。在这里，你可以发布脚本外包，分镜外包，动画外包，音效外包，后期剪辑外包，整个动画制作外包。";
    },
    set(title,type,content){
      document.title = title
      let head = document.getElementsByTagName('head');
      let meta = document.createElement('meta');
      // document.querySelector('meta[name="keywords"]').setAttribute('content', type)
      // document.querySelector('meta[name="description"]').setAttribute('content', content)
    },
    getActivityList(page){
      let _this=this;
      _this.fullscreenLoading = true
      let name=_this.searchIpt;
      let status=_this.selectStatesIndex;
      _this.currentPage=page;
      let pageSize=5;
      let productionType=_this.tagId;
      let url="/rrbi/activity/project-all?projectNature=1&activityName="+name+"&activityType=3&publishStatus=1&page="+page+"&pageSize="+pageSize+"&status="+status+"&productionType="+productionType+"&ti="+new Date().getMilliseconds();
      setTimeout(function (){
        _this.$axios.get(url).then(function(result){
          _this.data=result.data.response.list;
          _this.total = result.data.response.total
          _this.currentPage = result.data.response.pageNum
          _this.fullscreenLoading = false
        })
      },1100);
        this.setSeo();
        updateTdk.call(this);
    },
    getSystemTags(){
      let _this=this;
      let url="/rrbi/tags/system-tags?type=0&ti="+new Date().getMilliseconds();
      this.$axios.get(url).then(function(result){
        result.data.response.forEach((datas, index) => {
            _this.selectTypes.push({
              id: datas.id,
              tag: datas.tag,
              classType:"",
            })
        })
      })
    },
    selectState (index) {
      this.selectStatesIndex = index
      this.getActivityList(1);
    },
    selectType (index,item) {
      this.selectTypesIndex = index
      this.tagId=this.selectTypes[index].id
      this.selectTypes.forEach((datas, index) => {
        if(this.tagId==datas.id){
          datas.classType="active"
        }else{
          datas.classType=""
        }
      })
      this.getActivityList(1);

    },
  }
}
</script>

<style scoped lang="less">
//@import "../../../assets/less/stylePublic.less";
@import "../../course/detail/detail.less";
@import "../pro.less";
.page-project{
  padding-top: @NAVHEIGHT;
  .paeparation{
    margin: 0;
    &.sear-item{
      border-top: 10px solid #f6f6f6 ;
    }
  }
  .activities-content{
    padding: 0;
  }
  .pagintion-f {
    padding: 20px 0 0;
    text-align: center;
  }
}
</style>
